import { Button, Heading, Stack, Text } from '@chakra-ui/react';
import { Title } from '../../../atoms/Title';
import Cookies from 'js-cookie';
import { clearCognitoCookies } from '../clearCognitoCookies';

export interface IdleLoggedOutProps {
  onLoginClick: () => void;
}

const IdleLoggedOut = (props: IdleLoggedOutProps) => {
  const onLoginClick = (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.preventDefault();
    props.onLoginClick();
  };

  clearCognitoCookies(Cookies);

  const title = 'You were logged out';

  return (
    <>
      <Title title={title} />

      <Heading as="h1" mb={6}>
        {title}
      </Heading>

      <Text fontSize="lg" mb={6}>
        To protect sensitive information, you have been logged out.
      </Text>

      <Stack spacing={3}>
        <Button as="a" href="/" variant="secondary" size="lg" onClick={onLoginClick}>
          Return to login page
        </Button>
      </Stack>
    </>
  );
};

export default IdleLoggedOut;
